module.exports = __webpack_public_path__ + "static/media/art.5d2f53e8.jpg";